import React, { useState } from 'react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Cómo recibo mi compra?',
    answer: `Las opciones digitales (ebook y audios) se envían de forma instantánea a tu correo electrónico después de la compra.`
  }, {
    question: '¿Cuánto tarda el libro físico?',
    answer: `El libro físico se produce en 3–5 días hábiles y luego se envía. El tiempo total de entrega suele ser de 8–14 días hábiles dependiendo de tu país. Recibirás un número de seguimiento para rastrear tu pedido. Si eliges una opción digital, tendrás acceso inmediato mientras esperas el libro físico.`
  }, {
    question: '¿Necesito experiencia previa para usar este libro?',
    answer: `No. Este libro está diseñado para todo nivel, incluso si estás retomando tu fe después de mucho tiempo.`
  }, {
    question: '¿Puedo imprimir el ebook?',
    answer: `Sí. El ebook en PDF puede imprimirse para uso personal, siempre y cuando no se distribuya ni se revenda.`
  }];
  return <section className="section-card" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-33">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-blue-100" data-id="element-34">Todo lo que necesitas saber</p>
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="bg-gradient-to-br from-blue-900/40 to-purple-900/40 backdrop-blur-sm border border-blue-400/20 rounded-xl overflow-hidden hover:border-yellow-400/40 transition-all duration-300" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 hover:bg-blue-900/20 transition-colors" data-id="element-37">
                <span className="font-semibold text-white text-lg" data-id="element-38">
                  {faq.question}
                </span>
                <svg className={`w-5 h-5 text-yellow-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-39">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-40" />
                </svg>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-41">
                <div className="px-6 pb-5 text-blue-100 leading-relaxed" data-id="element-42">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}